import * as React from "react"
import Sidebar from "../components/Sidebar"

const PageLayout = ({ data, children }) => {

  return (
    <div>
    <div className="PostContainer max-w-screen-xl mx-auto px-4 flex flex-wrap my-8">
      <div className="PostContainer__Post lg:w-9/12">
        { children }
      </div>
      <div className="PostContainer__sidebar lg:w-3/12 px-5">
        <Sidebar posts={data.allMarkdownRemark.nodes}/>
      </div>
    </div>
    </div>
  )
}

export default PageLayout
